"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.composeTheme = exports.composeColorType = void 0;
var _polished = require("polished");
var _forEach = _interopRequireDefault(require("lodash/forEach"));
var _get = _interopRequireDefault(require("lodash/get"));
var _merge = _interopRequireDefault(require("lodash/merge"));
var _default = require("./default");
var _ = require("..");
var _certilogo = require("./certilogo");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var composeColorType = exports.composeColorType = function composeColorType(colorTypeTheme, baseColorTypeTheme, colorType) {
  var mergedTheme = (0, _merge["default"])({}, baseColorTypeTheme, colorTypeTheme);
  return _objectSpread(_objectSpread({
    color: mergedTheme.primaryColor,
    borderColor: mergedTheme.primaryColor,
    backgroundColor: mergedTheme.secondaryColor
  }, mergedTheme), {}, {
    button: _objectSpread({
      backgroundColor: mergedTheme.primaryColor,
      color: mergedTheme.secondaryColor,
      ripple: (0, _polished.transparentize)(0.6, mergedTheme.secondaryColor),
      borderColor: mergedTheme.secondaryColor,
      borderWidth: '0'
    }, colorTypeTheme.button),
    accordion: _objectSpread(_objectSpread({}, colorTypeTheme.accordion), {}, {
      trigger: _objectSpread({
        backgroundColor: mergedTheme.primaryColor,
        color: mergedTheme.secondaryColor,
        ripple: (0, _polished.transparentize)(0.6, mergedTheme.secondaryColor),
        borderColor: mergedTheme.secondaryColor,
        borderWidth: '0'
      }, (0, _get["default"])(colorTypeTheme, 'accordion.trigger')),
      body: _objectSpread({
        backgroundColor: mergedTheme.secondaryColor,
        color: mergedTheme.primaryColor
      }, (0, _get["default"])(colorTypeTheme, 'accordion.body'))
    }),
    tabs: _objectSpread(_objectSpread({}, colorTypeTheme.tabs), {}, {
      tab: _objectSpread(_objectSpread({}, (0, _get["default"])(colorTypeTheme, 'tabs.tab')), {}, {
        unselected: _objectSpread({
          backgroundColor: mergedTheme.secondaryColor,
          color: mergedTheme.primaryColor,
          borderColor: mergedTheme.primaryColor,
          borderWidth: '1px'
        }, (0, _get["default"])(colorTypeTheme, 'tabs.tab.unselected')),
        selected: _objectSpread({
          backgroundColor: mergedTheme.primaryColor,
          color: mergedTheme.secondaryColor,
          borderColor: mergedTheme.secondaryColor,
          borderWidth: '1px'
        }, (0, _get["default"])(colorTypeTheme, 'tabs.tab.selected'))
      }),
      tabPanel: _objectSpread({
        backgroundColor: mergedTheme.secondaryColor,
        color: mergedTheme.primaryColor
      }, (0, _get["default"])(colorTypeTheme, 'tabs.tabPanel'))
    }),
    modal: _objectSpread({
      backgroundColor: mergedTheme.secondaryColor,
      color: mergedTheme.primaryColor,
      overlayColor: (0, _polished.transparentize)(0.2, mergedTheme.primaryColor)
    }, colorTypeTheme.modal),
    modalAssistant: _objectSpread({
      backgroundColor: mergedTheme.secondaryColor,
      overlayColor: (0, _polished.transparentize)(0.2, mergedTheme.secondaryColor),
      color: mergedTheme.primaryColor,
      assistantColor: colorType === 'dark' ? _.color.darkBlue : _.color.white
    }, colorTypeTheme.modalAssistant),
    select: _objectSpread(_objectSpread({
      placeholderColor: (0, _polished.transparentize)(0.4, mergedTheme.primaryColor),
      accentColor: mergedTheme.secondaryAccentColor
    }, colorTypeTheme.select), {}, {
      option: _objectSpread(_objectSpread({}, (0, _get["default"])(colorTypeTheme, 'select.option')), {}, {
        unselected: _objectSpread({
          backgroundColor: mergedTheme.secondaryColor,
          color: mergedTheme.primaryColor
        }, (0, _get["default"])(colorTypeTheme, 'select.option.unselected')),
        selected: _objectSpread({
          backgroundColor: (0, _get["default"])(colorTypeTheme, 'form.accentColor') || mergedTheme.secondaryAccentColor,
          color: mergedTheme.secondaryColor
        }, (0, _get["default"])(colorTypeTheme, 'select.option.selected'))
      })
    }),
    form: _objectSpread({
      errorColor: mergedTheme.secondaryAccentColor,
      accentColor: mergedTheme.secondaryAccentColor,
      placeholderColor: (0, _polished.transparentize)(0.4, mergedTheme.primaryColor)
    }, colorTypeTheme.form),
    header: {
      top: _objectSpread({
        color: mergedTheme.primaryColor,
        backgroundColor: 'transparent',
        borderColor: mergedTheme.primaryColor,
        borderWidth: 0
      }, (0, _get["default"])(colorTypeTheme, 'header.top')),
      scroll: _objectSpread({
        color: mergedTheme.primaryColor,
        backgroundColor: mergedTheme.secondaryColor,
        borderColor: mergedTheme.primaryColor,
        borderWidth: 0
      }, (0, _get["default"])(colorTypeTheme, 'header.scroll'))
    },
    sidebar: _objectSpread({
      color: _.color.white,
      backgroundColor: (0, _polished.linearGradient)({
        colorStops: [_.color.azure, _.color.purple],
        fallback: _.color.azure
      })
    }, colorTypeTheme.sidebar),
    response: {
      authentic: _objectSpread({
        explosionGradient: ['#00B5E2', '#80BB91', '#FFC13F'],
        card: {
          backgroundColor: mergedTheme.secondaryColor
        }
      }, (0, _get["default"])(colorTypeTheme, 'response.authentic')),
      fake: _objectSpread({
        explosionGradient: ['#000000', '#2d2d2d', '#5b5b5b'],
        card: {
          backgroundColor: mergedTheme.secondaryColor
        }
      }, (0, _get["default"])(colorTypeTheme, 'response.fake')),
      impossible: _objectSpread({
        explosionGradient: 'linear-gradient(315deg, #7d55c7, #00b5e2 100%)',
        card: {
          backgroundColor: mergedTheme.secondaryColor
        }
      }, (0, _get["default"])(colorTypeTheme, 'response.impossible'))
    }
  });
};
var composeGlobal = function composeGlobal(inputObj) {
  return (0, _merge["default"])({}, _default.global, inputObj);
};
var composeTheme = exports.composeTheme = function composeTheme(name, themeConf) {
  var global = (0, _get["default"])(themeConf, 'global', {});
  var theme = {
    name: name,
    global: composeGlobal(global)
  };
  (0, _forEach["default"])(_certilogo.baseThemeConf, function (baseColorTypeTheme, key) {
    theme[key] = composeColorType((0, _get["default"])(themeConf, key, {}), baseColorTypeTheme, key);
  });
  return theme;
};